import { render, staticRenderFns } from "./travel-insurance-disclosure-message.vue?vue&type=template&id=15b3cf07&scoped=true"
import script from "./travel-insurance-disclosure-message.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-disclosure-message.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-disclosure-message.vue?vue&type=style&index=0&id=15b3cf07&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3cf07",
  null
  
)

export default component.exports